// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__vNm7m","label":"CategoryService_label__1FVoL","location":"CategoryService_location__CVaUU"};